import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export function useIsPunchOut() {
  const { query } = useRouter();
  const [isPunchOut, setIsPunchOut] = useState<boolean>(false);

  useEffect(() => {
    if (query.sid !== undefined) {
      setIsPunchOut(true);
    }
  }, [query]);

  return isPunchOut;
}
